import { Client, HexalInstance, IncyteInstance, NovartisInstance } from './enums';
import { IClientConfig } from './interfaces';

export const incyteConfig: IClientConfig = {
  clientName: Client.Incyte,
  deploymentTarget: {
    dev: 'https://incyte-app-dev.xircle.com',
    staging: 'https://incyte-app-staging.xircle.com',
    prod: 'https://incyte-app.xircle.com',
  },
  instances: [
    {
      name: IncyteInstance.Default,
      i18nNamespace: Client.Incyte,
      themeName: IncyteInstance.Default,
      isDefault: true,
      medInfoLink: 'https://incyte.com/contact-us/medical-information',
      medInfoText: `Incyte Biosciences Germany GmbH 
Incyte Medical Information
Mo. bis Fr. von 8 – 17 Uhr
    
Tel: +49 (0) 800 100 96 33
E-Mail: eumedinfo@incyte.com`,
      topics: [], // Empty array -> All topics enabled
    },
    {
      name: IncyteInstance.Onko,
      i18nNamespace: `${Client.Incyte}_${IncyteInstance.Onko}`,
      themeName: IncyteInstance.Onko,
      isDefault: false,
      medInfoLink: 'https://incyte.com/contact-us/medical-information',
      medInfoText: `Incyte Biosciences Germany GmbH 
Incyte Medical Information
Mo. bis Fr. von 8 – 17 Uhr

Tel: +49 (0) 800 100 96 33
E-Mail: eumedinfo@incyte.com`,
      topics: ['iclusig', 'pemazyre', 'minjuvi sep2024'],
    },
    {
      name: IncyteInstance.Derma,
      i18nNamespace: `${Client.Incyte}_${IncyteInstance.Derma}`,
      themeName: IncyteInstance.Derma,
      isDefault: false,
      medInfoLink: 'https://incyte.com/contact-us/medical-information',
      medInfoText: `Incyte Biosciences Germany GmbH 
Incyte Medical Information
Mo. bis Fr. von 8 – 17 Uhr

Tel: +49 (0) 800 100 96 33
E-Mail: eumedinfo@incyte.com`,
      topics: ['opzelura'],
    },
  ],
  devVersion: {
    major: 0,
    minor: 37,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 9,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 9,
    patch: 0,
  },
};

export const hexalConfig: IClientConfig = {
  clientName: Client.Hexal,
  deploymentTarget: {
    dev: 'https://hexal-app-dev.xircle.com',
    staging: 'https://hexal-app-staging.xircle.com',
    prod: 'https://hexal-app.xircle.com',
  },
  instances: [
    {
      name: HexalInstance.Default,
      i18nNamespace: Client.Hexal,
      themeName: HexalInstance.Default,
      isDefault: true,
      medInfoLink: 'https://www.hexal.de/kontakte/',
      medInfoText: `Hexal AG
Medizinischer Infoservice
Mo. - Fr. von 8 - 18 Uhr
Tel: +49 (0) 800 439 25 27
E-Mail: medwiss@hexal.com`,
      topics: [], // Empty array -> All topics enabled
    },
  ],
  devVersion: {
    major: 0,
    minor: 33,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 10,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const novartisConfig: IClientConfig = {
  clientName: Client.Novartis,
  deploymentTarget: {
    dev: 'https://novartis-app-dev.xircle.com',
    staging: 'https://novartis-app-staging.xircle.com',
    prod: 'https://novartis-app.xircle.com',
  },
  instances: [
    {
      name: NovartisInstance.Default,
      i18nNamespace: Client.Novartis,
      themeName: NovartisInstance.Default,
      isDefault: true,
      medInfoLink: 'https://infoservice.novartis.de/',
      medInfoText: `Novartis Pharma GmbH
Medizinischer Infoservice
Mo. - Fr. von 8 - 18 Uhr
Tel: +49 (0) 911 273 12 100
E-Mail: infoservice.novartis@novartis.com`,
      topics: [], // Empty array -> All topics enabled
    },
  ],
  devVersion: {
    major: 0,
    minor: 17,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 11,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const clientConfigs = [incyteConfig, hexalConfig, novartisConfig];
